import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/100w10tygodni/client/TrainingPlanClient.tsx");
